var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"idea"},[_c('div',{ref:"html",domProps:{"innerHTML":_vm._s(_vm.htmlText)}}),_c('img',{staticClass:"yh",attrs:{"src":require("../assets/image/yh.png"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }